import type { SidebarComponent } from '@tunasong/ui-lib'
import { Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { SidebarContext } from './sidebar-context.js'
import { SidebarSuggestion } from './sidebar-suggestion.js'

/**
 * The rail's Assist tool: suggestions first, then the musical context, each under its own heading.
 * It is the `Suggestions` tool (the persisted tool name is unchanged). Context is not listed in More panels,
 * so it has one home.
 */
export const SidebarAssistPanel: FC<SidebarComponent> = props => (
  <>
    <Typography variant="subtitle2" component="h3">
      Suggestions
    </Typography>
    <SidebarSuggestion {...props} />
    <Typography variant="subtitle2" component="h3">
      Context
    </Typography>
    <SidebarContext {...props} />
  </>
)
